import {FormCard} from "../components/FormCard";
import InputField from "../../../FinalForm/InputField";
import SelectField from "../../../FinalForm/SelectField";
import {
    FilterButton,
    TurnstileButton as Button
} from "../components/Button";
import {FiSave} from "react-icons/fi";
import SwitchField from "../../../FinalForm/SwitchField";
import {Form} from "react-final-form";
import React, {useEffect} from "react";
import Modal from "../../../components/My/Modal";
import {useSelector} from "react-redux";

const TYPES = [
    {"label": "String", "value": "STRING"},
    {"label": "Integer", "value": "INT"},
    {"label": "ANO/NE", "value": "BOOL"},
    {"label": "JSON", "value": "JSON"}
]
const ConfigModal = ({initData, configKeys, onSave, onClose, visible, saving}) => {
    let user = useSelector((state) => state.user);
    const keyOptions = (configKeys ?? []).map(k => ({label: k.label, value: k.key, valueType: k.valueType}));
    useEffect(() => {
        console.log("initData",initData);
    }, [initData]);

    const validate = (values) => {
        const errors = {};
        errors.rules = {};
        if (values?.rules) {
            const ticketAction = values.rules?.ticketAction ?? [];
            errors.rules.ticketAction = [];
            ticketAction.forEach((ticketActionItem, index) => {
                const type = ticketActionItem?.type ?? {};
                errors.rules.ticketAction[index] = {};
                if (parseInt(type) < 0) {
                    errors.rules.ticketAction[0].type = "Vložte nezáporné číslo";
                }
            });
        }
        return errors;
    };

    const onConfigKeyChange = (selected, form) => {
        // react-select předává celý option objekt (ne bare value) → vytáhni .value
        const value = (selected && typeof selected === "object") ? selected.value : selected;
        const configKey = keyOptions.find(item => item.value === value);
        if (configKey) {
            form.change("valueType", configKey.valueType);
        }
    }

    const renderValueInputByType = (type, value) => {
        switch (type) {
            case "STRING":
                return <InputField name="value" isMandatory label="Hodnota" inputType="text" />;
            case "INT":
                return <InputField name="value" isMandatory label="Hodnota" inputType="number" />;
            case "BOOL":
                // Backend "value" sloupec je String ("true"/"false"), ne JSON boolean — poslat
                // sem JS true/false se cestou přes gateway přetypuje na "1"/"" (PHP boolean
                // cast), takže se v DB uloží nesmysl. Musí jít vždy string, přesně jak ho
                // ConfigService.getBool() parsuje.
                return <SwitchField name="value" isMandatory label="Hodnota" trueValue="true" falseValue="false" />;
            case "JSON":
                return <InputField name="value" isMandatory label="Hodnota" inputType="text" />;
            default:
                return null;
        }
    };

    const _renderForm = (handleSubmit, values, form) => {
        return (
            <>
                <FormCard>
                    <SelectField
                        name="configKey"
                        options={keyOptions}
                        label="Název"
                        isMandatory
                        disabled={!!initData}
                        onChange={(selected) => onConfigKeyChange(selected, form)}
                    />
                    <SelectField
                        name="valueType"
                        options={TYPES}
                        label="Typ"
                        isMandatory
                        disabled
                        placeholder="-"
                    />
                    {/* Vykreslí pole podle aktuálního hodnota typu */}
                    {renderValueInputByType(values?.valueType, values?.value)}
                    <InputField name="description" label="Popis" isMandatory={false}/>
                </FormCard>

                {user?.user?.rights?.enigooTurniketsEdit && (
                    <FilterButton
                        type="button"
                        onClick={handleSubmit}
                        loading={saving}
                        text="Uložit"
                        icon={<FiSave size={12}/>}
                        fullWidth
                    />
                )}
            </>
        );
    };

    if (!visible) return null;
    return (
        <Form onSubmit={onSave} initialValues={initData}
              validate={validate}
              render={({handleSubmit, values, form}) => (
                  <Modal body={_renderForm(handleSubmit,values,form)} title={"Konfigurace"} visible={visible}
                         close={onClose}
                         accept={handleSubmit}
                         footer={<>
                             <Button outline={true} text={"Zavřít"} onClick={onClose}/>
                         </>
                         }
                  />
              )}
        />
    )
}
export default ConfigModal;
